import { FormattedMessage } from 'react-intl';

import { messages } from './messages';
import { NumberPropertyInput } from '../number-property-input';

import type { WidgetPropertyInput, WidgetPropertyDefinition } from '../../../config';

const HeightInput = ({ widget, updateWidget, ...rest }: WidgetPropertyInput) => {
  return <NumberPropertyInput updateWidget={(value) => updateWidget({ height: value })} value={widget.height} {...rest} />;
};

export const HeightProperty: WidgetPropertyDefinition = {
  id: 'height',
  label: <FormattedMessage {...messages.label} />,
  Component: HeightInput,
};
